import EventEmitter from 'events';
export const pubsub = new EventEmitter();

export const EVENTS = {
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  CONNECTIVITY_ERROR: 'CONNECTIVITY_ERROR',
  ACCOUNT_MISSING: 'ACCOUNT_MISSING'
};
